import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Trigger from '@cloud-sn/v-trigger';
import { isArray, isEqual } from '@cloud-sn/v-utils';
import Tree from '../tree';
import { buildComponentName } from '../utils';
import { DEFAULT_FIELD_NAMES, checkNodeForShowParent, isDisabledNode, isValidValue } from './utils';
import SingleMixin from './mixins/single';
import MultipleMixin from './mixins/multiple';
import SearchMixin from './mixins/search';
import placements from './placements';
export default {
  name: buildComponentName('TreeSelect'),
  provide: function provide() {
    return {
      treeSelectRoot: this
    };
  },
  mixins: [SingleMixin, MultipleMixin, SearchMixin],
  props: {
    prefixCls: {
      type: String,
      default: 'ux-select'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    searchValue: {
      type: String,
      default: ''
    },
    searchPlaceholder: {
      type: String,
      default: 'search'
    },
    autoClearSearchValue: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelInValue: {
      type: Boolean,
      default: false
    },
    maxTagCount: {
      type: [Number, String],
      default: -1
    },
    maxTagPlaceholder: {
      type: [String, Function],
      default: null
    },
    maxTagTextLength: {
      type: [Number, String],
      default: null
    },
    showCheckedStrategy: {
      type: String,
      default: 'SHOW_CHILD',
      validator: function validator(val) {
        return ['SHOW_ALL', 'SHOW_PARENT', 'SHOW_CHILD'].indexOf(val) > -1;
      }
    },
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    treeFieldNames: {
      type: Object,
      default: function _default() {
        return DEFAULT_FIELD_NAMES;
      }
    },
    treeCheckable: {
      type: Boolean,
      default: false
    },
    treeCheckStrict: {
      type: Boolean,
      default: false
    },
    treeLine: {
      type: Boolean,
      default: false
    },
    treeDefaultExpandAll: {
      type: Boolean,
      default: false
    },
    treeExpandedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    lazy: {
      type: Boolean,
      default: false
    },
    loadData: {
      type: Function,
      default: undefined
    },
    renderContent: {
      type: Function,
      default: null
    },
    filterOption: {
      type: Function,
      default: null
    },
    notFoundContent: {
      type: String,
      default: 'Not Found'
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Please select'
    },
    popupClass: {
      type: [String, Object, Array],
      default: ''
    },
    popupStyle: {
      type: Object,
      default: null
    },
    transition: {
      type: String,
      default: 'slide-up'
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    clearDisabled: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['large', 'default', 'small', ''].indexOf(val) > -1;
      }
    }
  },
  data: function data() {
    return {
      innerVisible: false,
      innerValue: [],
      searchInputValue: '',
      triggerRef: null,
      isMounted: false,
      selectedNodes: [],
      // 多增加一个treeValue变量,防止innerValue将最初的值直接渲染到页面上, 等值确定后再更新innerValue
      treeValue: []
    };
  },
  computed: {
    normalizeFieldNames: function normalizeFieldNames() {
      var fieldNames = this.fieldNames;
      return _objectSpread({}, DEFAULT_FIELD_NAMES, {}, fieldNames);
    },
    isMultiple: function isMultiple() {
      var multiple = this.multiple,
          treeCheckable = this.treeCheckable;
      return multiple || treeCheckable;
    },
    popupClasses: function popupClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          isMultiple = this.isMultiple;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-tree-dropdown"), true), _defineProperty(_ref, "".concat(prefixCls, "-dropdown--single"), !isMultiple), _defineProperty(_ref, "".concat(prefixCls, "-dropdown--multiple"), isMultiple), _ref;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setTreeValue(nVal);
    },
    visible: function visible(nVal) {
      this.setInnerVisible(nVal, false);
    }
  },
  created: function created() {
    var value = this.value,
        visible = this.visible,
        setInnerVisible = this.setInnerVisible,
        setTreeValue = this.setTreeValue;
    setTreeValue(value);
    setInnerVisible(visible, false);
    this.prevSelectionValue = null;
  },
  mounted: function mounted() {
    var triggerRef = this.$refs.triggerRef;

    if (triggerRef) {
      this.triggerRef = triggerRef;
    }

    this.isMounted = true;
  },
  methods: {
    getValidValue: function getValidValue(value) {
      var isMultiple = this.isMultiple;
      var val = isValidValue(value) ? value : [];
      val = isArray(val) ? val : [val];

      if (!isMultiple) {
        val = isValidValue(val[0]) ? [val[0]] : [];
      }

      return val;
    },
    setTreeValue: function setTreeValue(value) {
      this.treeValue = this.getValidValue(value);
    },
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var getValidValue = this.getValidValue,
          innerValue = this.innerValue,
          selectedNodes = this.selectedNodes;
      var val = getValidValue(value);

      if (!isEqual(val, innerValue)) {
        this.innerValue = val;
        this.treeValue = val;

        if (trigger) {
          var nVal = _toConsumableArray(val);

          var nodes = selectedNodes.map(function (node) {
            return _objectSpread({}, node.originNode);
          });
          this.$emit('input', nVal, nodes);
          this.$emit('change', nVal, nodes);
        }
      }
    },
    setInnerVisible: function setInnerVisible(visible) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerVisible = visible;

      if (trigger) {
        this.$emit('popup-visible-change', visible);
      }
    },
    setSelectionNodes: function setSelectionNodes(nodes) {
      this.selectedNodes = nodes;
    },
    forceUpdateTriggerAlign: function forceUpdateTriggerAlign() {
      var triggerRef = this.$refs.triggerRef,
          innerVisible = this.innerVisible;

      if (triggerRef && innerVisible) {
        this.$nextTick(function () {
          triggerRef.forcePopupAlign();
        });
      }
    },
    getSelectionValue: function getSelectionValue() {
      var formatSelectionValue = this.formatSelectionValue,
          selectedNodes = this.selectedNodes;
      return formatSelectionValue(selectedNodes);
    },
    setSelectionValue: function setSelectionValue(value) {
      var selectionValue = this.selectionValue;
      this.prevSelectionValue = selectionValue;
      this.selectionValue = value;

      if (!isEqual(selectionValue, value)) {
        this.forceUpdateTriggerAlign();
      }
    },
    formatSelectionValue: function formatSelectionValue() {
      var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var treeCheckable = this.treeCheckable,
          treeCheckStrict = this.treeCheckStrict,
          showCheckedStrategy = this.showCheckedStrategy,
          innerValue = this.innerValue,
          _this$normalizeFieldN = this.normalizeFieldNames,
          fieldValue = _this$normalizeFieldN.value,
          fieldChildren = _this$normalizeFieldN.children,
          fieldLabel = _this$normalizeFieldN.label;
      var nNodes = nodes;
      var nodeKeyObj = nNodes.reduce(function (r, node) {
        var nr = r;
        nr[node[fieldValue]] = 1;
        return nr;
      }, {});
      var missNodes = innerValue.filter(function (k) {
        return !(k in nodeKeyObj);
      }).map(function (k) {
        return {
          label: '',
          value: k
        };
      });

      if (treeCheckable && !treeCheckStrict) {
        if (showCheckedStrategy === 'SHOW_PARENT') {
          // TODO: 当直接上级是disabled,且上级是选中的,但上上级未被选中, 这种情况是否汇总, 现在是没有汇总在父级中的
          // eslint-disable-next-line
          nNodes = nNodes.filter(function (node) {
            return checkNodeForShowParent(node, nodeKeyObj, fieldValue);
          });
        } else if (showCheckedStrategy === 'SHOW_CHILD') {
          nNodes = nNodes.filter(function (node) {
            return !node[fieldChildren];
          });
        }
      }

      return [].concat(_toConsumableArray(missNodes), _toConsumableArray(nNodes.map(function (node) {
        return _objectSpread({}, node, {
          label: node[fieldLabel],
          value: node[fieldValue],
          children: node[fieldChildren]
        });
      }))).sort(function (a, b) {
        return a.pos - b.pos;
      });
    },
    getPopupWidth: function getPopupWidth() {
      var $el = this.$el,
          getPopupWidth = this.getPopupWidth,
          dropdownMatchSelectWidth = this.dropdownMatchSelectWidth,
          innerVisible = this.innerVisible;
      var style;

      if (innerVisible) {
        style = _defineProperty({}, dropdownMatchSelectWidth ? 'width' : 'minWidth', "".concat($el.offsetWidth, "px"));
        getPopupWidth.prev = style;
      } else {
        style = getPopupWidth.prev;
      }

      return style;
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.setInnerVisible(visible); // 关闭弹窗时清空搜索输入

      var searchInputValue = this.searchInputValue,
          setSearchInputValue = this.setSearchInputValue;

      if (!visible && searchInputValue) {
        setSearchInputValue('', false, false);
      }
    },
    onTreeValueChange: function onTreeValueChange(keys, nodes, checkAutoClear) {
      var isTriggerInputEvent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var setInnerValue = this.setInnerValue,
          setSelectionNodes = this.setSelectionNodes,
          clearSearchInputValue = this.clearSearchInputValue;
      setSelectionNodes(nodes);
      setInnerValue(keys, isTriggerInputEvent);
      clearSearchInputValue(checkAutoClear);
    },
    onClear: function onClear(e) {
      e.stopPropagation();
      var treeCheckable = this.treeCheckable,
          isMultiple = this.isMultiple,
          clearDisabled = this.clearDisabled,
          selectedNodes = this.selectedNodes,
          filedValue = this.normalizeFieldNames.value,
          onTreeValueChange = this.onTreeValueChange;
      var keys = [];
      var disabledNodes = [];

      if (isMultiple && !clearDisabled) {
        disabledNodes = selectedNodes.filter(function (node) {
          return isDisabledNode(node, treeCheckable);
        });
        keys = disabledNodes.map(function (node) {
          return node[filedValue];
        });
      }

      onTreeValueChange(keys, disabledNodes, false);
    },
    onTreeCheck: function onTreeCheck(checkedKeys, _ref2) {
      var checkedNodes = _ref2.checkedNodes;
      var onTreeValueChange = this.onTreeValueChange;
      onTreeValueChange(checkedKeys, checkedNodes);
    },
    onTreeSelect: function onTreeSelect(selectedKeys, _ref3) {
      var selectedNodes = _ref3.selectedNodes;
      var treeCheckable = this.treeCheckable,
          isMultiple = this.isMultiple,
          setTreeValue = this.setTreeValue,
          setInnerVisible = this.setInnerVisible,
          onTreeValueChange = this.onTreeValueChange;

      if (treeCheckable) {
        return;
      }

      if (!isMultiple) {
        setInnerVisible(false);
      }

      setTreeValue(selectedKeys);
      onTreeValueChange(selectedKeys, selectedNodes);
    },
    onTreeKeysChange: function onTreeKeysChange(keys, _ref4) {
      var nodes = _ref4.nodes,
          replace = _ref4.replace;
      var treeValue = this.treeValue,
          onTreeValueChange = this.onTreeValueChange; // 单个选择时不触发,只触发onTreeCheck

      if (replace) {
        onTreeValueChange(keys, nodes, false, !isEqual(treeValue, keys));
      }
    },
    getTreeRef: function getTreeRef() {
      return this.$refs.treeRef;
    },
    renderTrigger: function renderTrigger() {
      var isMultiple = this.isMultiple,
          renderSingleTrigger = this.renderSingleTrigger,
          renderMultipleTrigger = this.renderMultipleTrigger;
      return isMultiple ? renderMultipleTrigger() : renderSingleTrigger();
    },
    renderTree: function renderTree() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          treeValue = this.treeValue,
          treeData = this.treeData,
          treeFieldNames = this.treeFieldNames,
          treeCheckable = this.treeCheckable,
          treeCheckStrict = this.treeCheckStrict,
          treeLine = this.treeLine,
          treeDefaultExpandAll = this.treeDefaultExpandAll,
          treeExpandedKeys = this.treeExpandedKeys,
          lazy = this.lazy,
          loadData = this.loadData,
          multiple = this.multiple,
          renderContent = this.renderContent,
          filterOption = this.filterOption,
          onTreeCheck = this.onTreeCheck,
          onTreeSelect = this.onTreeSelect,
          onTreeKeysChange = this.onTreeKeysChange;

      var props = _defineProperty({
        prefixCls: "".concat(prefixCls, "-tree"),
        dataSource: treeData,
        filedNames: treeFieldNames,
        checkable: treeCheckable,
        checkStrict: treeCheckStrict,
        showLine: treeLine,
        defaultExpandAll: treeDefaultExpandAll,
        expandedKeys: treeExpandedKeys,
        lazy: lazy,
        loadData: loadData,
        renderContent: renderContent,
        filterOption: filterOption,
        selectable: !treeCheckable,
        multiple: multiple
      }, treeCheckable ? 'checkedKeys' : 'selectedKeys', _toConsumableArray(treeValue));

      var on = _defineProperty({
        check: onTreeCheck,
        select: onTreeSelect
      }, treeCheckable ? 'checked-keys-change' : 'selected-keys-change', onTreeKeysChange);

      return h(Tree, _mergeJSXProps([{}, {
        props: props,
        on: on,
        ref: 'treeRef'
      }]));
    },
    renderPopup: function renderPopup() {
      var h = this.$createElement;
      var renderSinglePopup = this.renderSinglePopup,
          renderTree = this.renderTree,
          isMultiple = this.isMultiple,
          renderNotFound = this.renderNotFound;
      return h("div", {
        "slot": "popup"
      }, [isMultiple ? [renderTree(), renderNotFound()] : [renderSinglePopup(), renderTree(), renderNotFound()]]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        disabled = this.disabled,
        innerVisible = this.innerVisible,
        popupClasses = this.popupClasses,
        popupClass = this.popupClass,
        popupStyle = this.popupStyle,
        builtinPlacements = this.builtinPlacements,
        transition = this.transition,
        getPopupContainer = this.getPopupContainer,
        getPopupWidth = this.getPopupWidth,
        onPopupVisibleChange = this.onPopupVisibleChange,
        renderTrigger = this.renderTrigger,
        renderPopup = this.renderPopup;

    if (!this.isMounted) {
      return null;
    }

    var popupWidth = getPopupWidth();
    var triggerProps = {
      prefixCls: "".concat(prefixCls, "-dropdown"),
      visible: innerVisible,
      actions: disabled ? [] : ['click'],
      popupClass: [popupClasses, popupClass],
      popupStyle: _objectSpread({
        maxHeight: '400px',
        overflow: 'auto'
      }, popupWidth, {}, popupStyle),
      builtinPlacements: builtinPlacements,
      popupPlacement: 'bottomLeft',
      popupTransitionName: transition,
      getPopupContainer: getPopupContainer,
      // initPopupFirst: lazy && isFunction(loadData),
      initPopupFirst: true
    };
    var on = {
      'popup-visible-change': onPopupVisibleChange
    };
    return h(Trigger, _mergeJSXProps2([{}, {
      props: triggerProps,
      on: on,
      ref: 'triggerRef'
    }]), [renderTrigger(), renderPopup()]);
  }
};